import { style } from '@vanilla-extract/css';

export const listItemElement = style({
  position: 'relative',

  selectors: {
    '&::marker': {
      color: 'var(--marker-color, inherit)',
      fontWeight: 'var(--marker-font-weight, inherit)',
      fontFamily: 'var(--marker-font-family, inherit)',
      fontSize: 'var(--marker-font-size, inherit)',
      fontStyle: 'var(--marker-font-style, inherit)',
      fontVariantNumeric: 'tabular-nums',
    },
  },

  '@media': {
    'only screen and (--mobile)': {
      selectors: {
        '&::marker': {
          fontSize: 'var(--marker-mobile-font-size, var(--marker-font-size))',
        },
      },
    },
  },
});
